// Detect stale webpack chunks after deploy (cached numeric chunk IDs) and force a full reload.

import { forceHardReload } from "./forceHardReload";
import {
  canAttemptFrontendReload,
  markFrontendReloadAttempt,
} from "./frontendReloadGuard";

function isWebpackChunkFailure(reason) {
  const msg = String(reason?.message || reason || "");
  return (
    /Loading chunk [\da-zA-Z_-]+ failed/i.test(msg) ||
    /ChunkLoadError/i.test(msg) ||
    /Cannot find module ['"]?\d+['"]?/i.test(msg) ||
    /Cannot read properties of undefined \(reading 'call'\)/i.test(msg) ||
    /\.chunk\.bundle\.js/i.test(msg)
  );
}

function recoverFromStaleChunk(reason) {
  if (!canAttemptFrontendReload()) return;
  if (!isWebpackChunkFailure(reason)) return;

  console.warn("[chunkLoadRecovery] Stale frontend bundle detected — hard reload", reason);
  markFrontendReloadAttempt();
  void forceHardReload();
}

/** Call once at app bootstrap (before React mount). */
export function initChunkLoadRecovery() {
  if (typeof window === "undefined") return;

  window.addEventListener("unhandledrejection", (event) => {
    recoverFromStaleChunk(event.reason);
  });

  window.addEventListener("error", (event) => {
    recoverFromStaleChunk(event.error || event.message);
  });
}
